import { UniqueIdentifier } from '@dnd-kit/core';
import React from 'react';

import { HStack, Text } from '@eluve/components';
import { GroupBlock } from '@eluve/llm-outputs';

import { BlockPicker } from '../BlockPicker';
import { AsBuilderBlock } from '../utilities';

export interface GroupBlockControlProps {
  parentId: UniqueIdentifier | null;
  group: AsBuilderBlock<GroupBlock>;
}

export const GroupBlockControl: React.FC<GroupBlockControlProps> = ({
  group,
}) => {
  return (
    <HStack gap={3}>
      <Text size="md" weight="medium" className="text-nowrap">
        Add
      </Text>
      <BlockPicker parentId={group.id} />
    </HStack>
  );
};
